export const responseTexts = {
    okButton: 'Ok',
    successDefaultTitle: 'Success!',
    successDefaultText: 'Գորցողությունը հաջողությամբ կատարվեց',
    errorDefaultTitle: 'Error!',
    errorDefaultText: 'Ինչ որ բան այն չէ, Խնդրում ենք  փորձել կրկին',
    expired: 'Խնդրում ենք կրկին փորձել մուտք գործել',

};
